const getDefaultState = () => ({
  translations: {},
  reviewerId: null
})

export const state = getDefaultState

export const mutations = {
  ACTIVATE (state, id) {
    state.reviewerId = id
  },
  DEACTIVATE (state) {
    state.reviewerId = null
  },
  SET_TRANSLATIONS (state, { bases, strings, comments }) {
    state.translations = Object.fromEntries(bases.map((base) => {
      return [base.id, {
        ...base,
        string: strings.find(string => string.base === base.id || string.base === (base.grouped_with || {}).id),
        comments: comments.filter(comment => comment.target === base.id || comment.target === (base.grouped_with || {}).id)
      }]
    }))
  },
  SET_COMMENTS (state, { base, comment }) {
    const translation = state.translations[base.id]
    translation.comments = [...translation.comments, comment]

    state.translations = {
      ...state.translations,
      [base.id]: translation
    }
  },
  SET_TRANSLATION (state, { translation, string }) {
    const idsToUpdate = new Set([
      string.base,
      translation.base.id,
      (translation.base.grouped_with || {}).id
    ].filter(id => id))
    
    idsToUpdate.forEach((id) => {
      const updatedTranslation = {
        ...state.translations[id],
        string
      }

      state.translations = {
        ...state.translations,
        [id]: updatedTranslation
      }
    })
  }
}

export const getters = {
  showTranslationBanner: state => !!state.reviewerId,
  reviewerId: state => state.reviewerId,
  base: state => id => state.translations[id] || {},
  comments: state => id => (state.translations[id] || {}).comments || []
}

export const actions = {
  async GET_ALL ({ commit, getters }, locale) {
    const data = await this.$publicAPI.$quietGet(
      `i18n/get-all/${locale}/`,
      { params: { reviewer: getters.reviewerId } }
    )
    commit('SET_TRANSLATIONS', data)
  },
  async ADD_COMMENT ({ commit, getters }, { translation, body }) {
    const { data } = await this.$publicAPI.quietPost(`i18n/${translation.id}/comment/`, {
      ...body,
      reviewer: getters.reviewerId
    })
    commit('SET_COMMENTS', data)
  },
  async APPROVE ({ commit, getters }, translation) {
    const { data } = await this.$publicAPI.quietPost(`i18n/${translation.base.string.id}/approve/`, {
      reviewer: getters.reviewerId
    })
    commit('SET_TRANSLATION', { translation, string: data })
  },
  async EDIT ({ commit, getters }, { translation, translated, approve }) {
    const { data } = await this.$publicAPI.quietPost(`i18n/${translation.base.string.id}/edit/`, {
      reviewer: getters.reviewerId,
      translated,
      approve
    })
    commit('SET_TRANSLATION', { translation, string: data })
  }
}
